import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { Helmet } from 'react-helmet-async';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {

  return (
  <Container maxWidth="sm" className="privacy-policy-container">
    <Helmet>
      <title>NHHS Analytics | Privacy Policy</title>
    </Helmet>
    <Box className="privacy-policy-header">
      <Typography variant="h1" className="privacy-policy-title">
        Privacy Policy
      </Typography>
      <Typography variant="subtitle1" className="privacy-policy-subtitle">
        Effective Date: July 4, 2025
      </Typography>
    </Box>
    <Divider className="privacy-policy-divider" />
    <Box className="privacy-policy-section">
      <Typography variant="h2" className="privacy-policy-section-title">
        What Information We Collect
      </Typography>
      <Typography paragraph>
        When you sign in using Google, we collect your Google account information (name, email, and profile image) for authentication and access to the NHHS Analytics Dashboard. If you use the GPA Calculator, we also store your course and grade data (course name, credits, grade, semester) securely in your account. No other personal data is collected.
      </Typography>
    </Box>
    <Box className="privacy-policy-section">
      <Typography variant="h2" className="privacy-policy-section-title">
        How We Use Your Information
      </Typography>
      <Typography paragraph>
        Your Google account information is used only to verify your identity and provide access to our services. Your GPA Calculator data is stored securely and is only accessible to you. We do not sell, share, or use your personal data or GPA data for any purpose other than providing the service. You can export or permanently delete your GPA data at any time.
      </Typography>
    </Box>
    <Box className="privacy-policy-section">
      <Typography variant="h2" className="privacy-policy-section-title">
        Cookies & Session
      </Typography>
      <Typography paragraph>
        We use cookies or session storage only to keep you logged in during your session. No tracking or analytics cookies are used. Your GPA data is encrypted in transit and at rest.
      </Typography>
    </Box>
    <Box className="privacy-policy-section">
      <Typography variant="h2" className="privacy-policy-section-title">
        Contact
      </Typography>
      <Typography paragraph>
        If you have any questions about your privacy or how your information is used, please contact the NHHS Analytics team at <span className="privacy-policy-contact">admin@nhhs-analytics.org</span>.
      </Typography>
    </Box>
    <Divider className="privacy-policy-divider" />
    <Typography variant="caption" className="privacy-policy-footer-text">
      This Privacy Policy is effective as of the date stated above and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.
    </Typography>
  </Container>
);
};

export default PrivacyPolicy;
